import { createSlice } from '@reduxjs/toolkit';
import { filter } from 'lodash';
import Axios from '../../utils/axiosInstance';

const initialState = {
  workshopList: [],
  workshop: null,
  workshopTask: null,
  workShopTaskIdData: [],
  workShopLog: [],
  workshopId: null,
};

const slice = createSlice({
  name: 'workshop',
  initialState,
  reducers: {
    // START LOADING
    startLoading(state) {
      state.isLoading = true;
    },

    // HAS ERROR
    hasError(state, action) {
      state.isLoading = false;
      state.error = action.payload;
    },
    setWorkshopId: (state, action) => {
      state.workshopId = action.payload;
    },

    // DELETE ORDER
    deleteWorkshop(state, action) {
      const deleteWorkshop = filter(state.workshop, (workshop) => workshop.id !== action.payload);
      state.workshop = deleteWorkshop;
    },

    // GET ORDERS
    getWorkshopListSuccess(state, action) {
      state.isLoading = false;
      state.workshopList = action.payload;
    },
    // Create Workshop
    createWorkshop(state, action) {
      state.isLoading = false;
      state.workshop = action.payload;
    },
    createWorkshopTask(state, action) {
      state.isLoading = false;
      state.workshopTask = action.payload;
    },
    WorkshopTaskFindByID(state, action) {
      state.isLoading = false;
      state.workShopTaskIdData = action.payload;
    },
    WorkShopLogData(state, action) {
      state.isLoading = false;
      state.workShopLog = action.payload;
    },
  },
});

// Reducer
export default slice.reducer;

// Actions
export const { onToggleFollow, deleteWorkshop } = slice.actions;

// ----------------------------------------------------------------------

export function dispatchDeleteWorkshop(workshopId) {
  return async (dispatch) => {
    dispatch(slice.actions.startLoading());
    try {
      await Axios.delete(`/workshop/${workshopId}`);
      dispatch(slice.actions.deleteWorkshop(workshopId));
    } catch (error) {
      dispatch(slice.actions.hasError(error));
    }
  };
}

// ----------------------------------------------------------------------

export function dispatchNewWorkshop(workshop) {
  return async (dispatch) => {
    dispatch(slice.actions.startLoading());
    try {
      const response = await Axios.post('/workshop', workshop);
      dispatch(slice.actions.createWorkshop(response.data.data));
    } catch (error) {
      dispatch(slice.actions.hasError(error));
    }
  };
}

// ----------------------------------------------------------------------

export function dispatchUpdateWorkshop(workshop) {
  return async (dispatch) => {
    dispatch(slice.actions.startLoading());
    try {
      const response = await Axios.put(`/workshop/${workshop.id}`, workshop);
      dispatch(slice.actions.createWorkshop(response.data.data));
    } catch (error) {
      dispatch(slice.actions.hasError(error));
    }
  };
}

// ----------------------------------------------------------------------

export function getWorkshopList() {
  return async (dispatch) => {
    dispatch(slice.actions.startLoading());
    try {
      const response = await Axios.get('/workshop');
      dispatch(slice.actions.getWorkshopListSuccess(response.data.data));
    } catch (error) {
      dispatch(slice.actions.hasError(error));
    }
  };
}

// ------------------------------ Workshop task create ----------------------------------------

export function dispatchNewWorkshopTask(workshop) {
  return async (dispatch) => {
    dispatch(slice.actions.startLoading());
    try {
      const response = await Axios.post('/workshop-task', workshop);
      dispatch(slice.actions.createWorkshopTask(response.data.data));
    } catch (error) {
      dispatch(slice.actions.hasError(error));
    }
  };
}

// ----------------------- Workshop task id find -------------------------------------

export function getWorkshopTaskFindByID(id) {
  return async (dispatch) => {
    if (!id) return; // guard clause

    dispatch(slice.actions.startLoading());
    try {
      const response = await Axios.get(`/workshop-task/${id}`);
      dispatch(slice.actions.WorkshopTaskFindByID(response.data.data));
    } catch (error) {
      dispatch(slice.actions.hasError(error));
    }
  };
}

export function getWorkShopLogById(id) {
  return async (dispatch) => {
    dispatch(slice.actions.startLoading());
    try {
      const response = await Axios.get(`/workshop-task/log/${id}`);
      dispatch(slice.actions.WorkShopLogData(response.data.data));
    } catch (error) {
      dispatch(slice.actions.hasError(error));
    }
  };
}
